module.exports = __webpack_public_path__ + "static/media/cq_messaggi_e.70d909c7.svg";